<template>
    <div class="zone-container">
        <label v-if="hideLabel==false">ZipCode / Zone <slot name="label"></slot> </label>


        <div
                v-if="zoneId === null"
                class="search-block">
            <input
                    v-model="searchString"
                    ref="searchInput"
                    v-bind:placeholder="placeholder"
                    type="text"
                    class="form-control"
                    :class="customInputClass"
                    autocomplete="false"
            >
            <ul class="zones-list">
                <li
                        v-for="zone in foundZones"
                        v-on:click="selectZone(zone)">
                    <span v-html="zone.label"></span>
                </li>
            </ul>
            <div
                    v-if="searching"
                    class="progress">
                Searching for zones in please wait...
            </div>
            <div
                    v-if="foundZones !== null && foundZones.length === 0"
                    class="fail">
                Nothing found...
            </div>
            <div
                    v-if="countryCode === null"
                    class="fail">
                Country is Missing
            </div>
        </div>
        <template v-else>
            <div v-if="loadingZone">
                Loading zone...
            </div>
            <div v-else>
                <span class="btn btn-primary">{{ zone.label }}</span>
                <span
                        v-on:click="unselect"
                        class="btn btn-primary">
                    <i class="fa fa-times"></i>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            zoneId: Number,
            countryCode: String,
            placeholder: String,
            hideLabel: Boolean,
            addressApi: Object,
            lodashDebounce: Function,
            customInputClass: String
        },
        data() {
            return {
                zone: null,
                loadingZone: false,
                searchString: '',
                searching: false,
                foundZones: null,
            };
        },
        methods: {
            selectZone(zone) {
                this.searchString = '';
                this.foundZones = null;
                this.$emit('update:zoneId', Number.parseInt(zone.id));
            },
            unselect() {
                this.$emit('update:zoneId', null);
            },
            async search() {
                this.searching = true;
                // IMPROVEMENT: try to catch all errors and gracefully report to user
                this.foundZones = (await this.addressApi.getZones(this.searchString, this.countryCode));
                this.searching = false;
            },
        },
        watch: {
            searchString() {
                this.foundZones = null;
                if (this.searchString.length > 2 && this.countryCode !== null) {
                    this.searchDebounced();
                }
            },
            countryCode() {
                this.foundZones = null;
                if (this.searchString.length > 2 && this.countryCode !== null) {
                    this.search();
                }
            },
            zoneId: {
                async handler() {
                    if (this.zoneId === null) {
                        this.zone = null;
                        return;
                    }
                    this.loadingZone = true;
                    // IMPROVEMENT: implement zone cache over api, to avoid reloading zone via api call after selection ?
                    // IMPROVEMENT: try to catch all errors and gracefully report to user
                    this.zone = (await this.addressApi.getZone(this.zoneId));
                    this.loadingZone = false;
                },
                immediate: true, // to run the watcher at component creation
            },
        },
        computed: {
            searchDebounced() {
                return this.lodashDebounce(this.search, 500);
            }
        }
    };
</script>

<style scoped lang="scss">
    .zone-container {
        position: relative;
    }

    .zones-list {
        padding: 0;
        margin: 0;
        background-color: #b8cfef;
        position: absolute;
        width: 100%;
        z-index: 333;
    }

    .zones-list li {
        padding: 4px;
    }

    .zones-list li:hover {
        background: #363d47;
        color: white;
        cursor: pointer;
    }

    .progress {
        color: green;
    }

    .fail {
        color: red;
    }

    .mandatory-value {
        background-color: red;
        color: white;
        padding: 2px;
    }
</style>
